import Decimal from 'decimal.js';

import { Currency } from '../../types/currency';

// Fixed LTV at loan issue. Per spec. Decimal so consumers stay in
// Decimal-arithmetic throughout (forces .mul/.div instead of native *).
export const ISSUE_LTV = new Decimal('0.5');

// Origination fee rate is read from widget-config.json (originationFeeRate, "1.5"%).

// Slider piecewise-exponential midpoint per currency. The slider maps t∈[0,1]
// log-linearly: [0, 0.5] covers min→midpoint, [0.5, 1] covers midpoint→max.
// Story requires "100,000 is the middle" for EUR; values for other currencies
// are scaled equivalents (rounded for nicer slider snap behavior).
export const SLIDER_MIDPOINT: Record<Currency, Decimal> = {
  [Currency.Eur]: new Decimal(100_000),
  [Currency.Czk]: new Decimal(2_500_000),
  [Currency.Usdc]: new Decimal(100_000),
  [Currency.Usdt]: new Decimal(100_000),
  [Currency.Chf]: new Decimal(100_000),
  [Currency.Pln]: new Decimal(425_000),
};
